import { render, staticRenderFns } from "./the-import.vue?vue&type=template&id=5f26751d&scoped=true"
import script from "./the-import.vue?vue&type=script&lang=js"
export * from "./the-import.vue?vue&type=script&lang=js"
import style0 from "./the-import.vue?vue&type=style&index=0&id=5f26751d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26751d",
  null
  
)

export default component.exports